import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { OfferDetails } from "../../offers.types";
import { requestGetOffer } from "./getOffer.request";

const useOffer = (
  offerId?: string,
  options?: QueryOptions<OfferDetails, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["special-offer", offerId],
    queryFn: async () => await requestGetOffer(offerId),
    enabled: !!offerId,
    ...options
  });

  return { offer: data, ...rest };
};

export default useOffer;
